/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyCustomerTagsRequest
 */
export interface ShopifyCustomerTagsRequest {
  /**
   *
   * @type {string}
   * @memberof ShopifyCustomerTagsRequest
   */
  integrationId: string;
}

/**
 * Check if a given object implements the ShopifyCustomerTagsRequest interface.
 */
export function instanceOfShopifyCustomerTagsRequest(
  value: object,
): value is ShopifyCustomerTagsRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  return true;
}

export function ShopifyCustomerTagsRequestFromJSON(
  json: any,
): ShopifyCustomerTagsRequest {
  return ShopifyCustomerTagsRequestFromJSONTyped(json, false);
}

export function ShopifyCustomerTagsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyCustomerTagsRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
  };
}

export function ShopifyCustomerTagsRequestToJSON(
  json: any,
): ShopifyCustomerTagsRequest {
  return ShopifyCustomerTagsRequestToJSONTyped(json, false);
}

export function ShopifyCustomerTagsRequestToJSONTyped(
  value?: ShopifyCustomerTagsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
  };
}
